export default __webpack_public_path__ + "static/anthony-5dd0a35074f7bccfbca0371d765da192.png";